const GA_ID = 'G-21X789TL6J';
const isDev = process.env.NODE_ENV === 'development';

function gtag() {
  if (typeof window.gtag === 'function') {
    window.gtag.apply(null, arguments);
  }
}

// SPA page view — call on every route change
export function trackPageView(path) {
  if (isDev) console.log('[GA4] page_view', path);
  gtag('config', GA_ID, { page_path: path });
}

// Generic event helper
export function trackGA4Event(eventName, params = {}) {
  if (isDev) console.log(`[GA4] ${eventName}`, params);
  gtag('event', eventName, params);
}

// --- Catalog events ---

export function trackViewProductList(pagePath, skuCount) {
  trackGA4Event('view_product_list', { page_path: pagePath, sku_count: skuCount });
}

export function trackViewProduct(product, pagePath) {
  trackGA4Event('view_product', {
    voltide_sku_code: product.voltide_sku_code || product.sku,
    sku_type: product.sku_type,
    pcs_kw: product.pcs_kw,
    battery_kwh: product.battery_kwh,
    page_path: pagePath,
  });
}

export function trackAddToQuoteCart(product, mode, quantity = 1) {
  trackGA4Event('add_to_quote_cart', {
    voltide_sku_code: product.voltide_sku_code || product.sku,
    mode,
    quantity,
  });
}

// --- Quote flow events ---

export function trackViewQuoteCart(itemsCount, sitesCount) {
  trackGA4Event('view_quote_cart', { items_count: itemsCount, sites_count: sitesCount });
}

export function trackStartRfq(source, sitesCount) {
  trackGA4Event('start_rfq', { source, sites_count: sitesCount });
}

export function trackSubmitRfq(rfqId, sitesCount, docsUploaded) {
  trackGA4Event('submit_rfq', { rfq_id: rfqId, sites_count: sitesCount, docs_uploaded: docsUploaded });
}

// --- Savings events ---

export function trackOpenCalculator(pagePath) {
  trackGA4Event('open_calculator', { page_path: pagePath });
}

export function trackSavingsEstimate(useCase, estimatedRange) {
  trackGA4Event('savings_estimate_created', { use_case: useCase, estimated_savings_range: estimatedRange });
}
